import {Validators} from '@angular/forms';

import {BaseControl, DatepickerControl, SelectControl} from '../../app/shared/classes/controls';

import {ComponentTypesEnum} from '../../app/shared/enums/common';

export const FeesArraySelector = 'feesArray';
export const FeeGroupSelector = 'feeGroup';
export const FeeTypeSelector = 'feeType';
export const FeeSelector = 'feePlan';
export const FeeStartDate = 'feeStartDate';
export const FeeEndDate = 'feeEndDate';

export interface FeesFormControlsInterface {
    feeGroup: BaseControl;
    feeType: SelectControl;
    fee: SelectControl;
    startDate: DatepickerControl;
    endDate: DatepickerControl;
}

export const FeesFormControls = (isValidityUpdate = false): FeesFormControlsInterface => {
    return {
        feeGroup: new BaseControl({
            name: FeeGroupSelector,
            value: null,
            placeholder: 'Fee Category',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            disabled: true
        }),
        feeType: new SelectControl({
            name: FeeTypeSelector,
            value: null,
            placeholder: 'Fee Plan',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            disabled: isValidityUpdate
        }),
        fee: new SelectControl({
            name: FeeSelector,
            value: null,
            placeholder: 'Fee',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            disabled: isValidityUpdate
        }),
        startDate: new DatepickerControl({
            name: FeeStartDate,
            value: '',
            placeholder: 'Valid From',
            validators: [],
            componentType: ComponentTypesEnum.Datepicker,
            floatingLabelNever: true,
            resetable: true
        }),
        endDate: new DatepickerControl({
            name: FeeEndDate,
            value: '',
            placeholder: 'Valid To',
            validators: [],
            componentType: ComponentTypesEnum.Datepicker,
            floatingLabelNever: true,
            resetable: true
        }),
    };
};


export const BulkFeesFormControls = (isValidityUpdate = false): FeesFormControlsInterface => {
    return {
        feeGroup: new SelectControl({
            name: FeeGroupSelector,
            value: null,
            placeholder: 'Fee Category',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            disabled: isValidityUpdate,
            hidden: isValidityUpdate
        }),
        feeType: new SelectControl({
            name: FeeTypeSelector,
            value: null,
            placeholder: 'Fee Plan',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            disabled: isValidityUpdate,
            hidden: isValidityUpdate
        }),
        fee: new SelectControl({
            name: FeeSelector,
            value: null,
            placeholder: 'Fee',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            disabled: isValidityUpdate,
            hidden: isValidityUpdate
        }),
        startDate: new DatepickerControl({
            name: FeeStartDate,
            value: '',
            placeholder: 'Valid From',
            validators: [],
            componentType: ComponentTypesEnum.Datepicker,
            floatingLabelNever: true,
            resetable: true,
            disabled: isValidityUpdate,
            hidden: isValidityUpdate
        }),
        endDate: new DatepickerControl({
            name: FeeEndDate,
            value: '',
            placeholder: 'Valid To',
            validators: isValidityUpdate ? [Validators.required] : [],
            componentType: ComponentTypesEnum.Datepicker,
            floatingLabelNever: true,
            resetable: true
        }),
    };
};
